<template>
  <div class="contract-information-page pb60">
    <!-- 标题条（questionnaireAdd 同款框架：返回按钮左上、标题居中） -->
    <div class="title-box">
      <el-button type="default" size="small" @click="goBack">返回</el-button>
      <span>认证审核详情</span>
    </div>

    <!-- 基本信息 -->
    <div class="base">
      <div class="title" @click="isExpandBase = !isExpandBase">
        <div class="title-config">
          <i :class="isExpandBase ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
          基本信息
        </div>
      </div>
      <div v-show="isExpandBase" class="base-body">
      <!-- FOUR-2956①：一行三列（参考"通用详情"样式），标注经验长文本独占整行 -->
      <el-row :gutter="24">
        <el-col :span="8">
          <span class="contract-base-title">姓名：</span>
          <span class="contract-base-content">
            {{ detail.name || '-' }}
            <el-tag v-if="detail.identity" size="mini" type="success" class="ml10">{{ identityName }}</el-tag>
            <el-tag v-if="isCertChange" size="mini" type="warning" class="ml10">认证变更</el-tag>
          </span>
        </el-col>
        <el-col :span="8">
          <span class="contract-base-title">手机号：</span>
          <span class="contract-base-content">{{ detail.mobileNo || '-' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="contract-base-title">邮箱：</span>
          <span class="contract-base-content">{{ detail.email || '-' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="contract-base-title">身份证号：</span>
          <span class="contract-base-content">{{ detail.idCode || '-' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="contract-base-title">{{ isStudent ? '所在院校：' : '所在机构：' }}</span>
          <span class="contract-base-content">{{ detail.orgName || '-' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="contract-base-title">{{ isStudent ? '所在专业：' : '所在科室：' }}</span>
          <span class="contract-base-content">{{ detail.deptName || '-' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="contract-base-title">职称：</span>
          <span class="contract-base-content">{{ detail.titleName || '-' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="contract-base-title">职务：</span>
          <span class="contract-base-content">{{ detail.position || '-' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="contract-base-title">工作起始年份：</span>
          <span class="contract-base-content">{{ detail.workStartYear || '-' }}</span>
        </el-col>
        <el-col :span="24">
          <span class="contract-base-title">标注经验：</span>
          <div class="contract-base-content">{{ detail.labelExperience || '-' }}</div>
        </el-col>
      </el-row>
      <img
        v-show="detail.approveVO && detail.approveVO.approveState !== 'N' && getApproveImg()"
        class="approve-img"
        :src="getApproveImg()"
        alt=""
      />
      </div>
    </div>

    <!-- 学历信息 -->
    <div class="base">
      <div class="title" @click="isExpandEdu = !isExpandEdu">
        <div class="title-config">
          <i :class="isExpandEdu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
          学历信息
        </div>
      </div>
      <div v-show="isExpandEdu" class="base-body">
      <el-row :gutter="24">
        <el-col :span="8">
          <span class="contract-base-title">起止时间：</span>
          <span class="contract-base-content">{{ detail.eduStart || '-' }} ~ {{ detail.eduEnd || '-' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="contract-base-title">毕业院校：</span>
          <span class="contract-base-content">{{ detail.graduatedFrom || '-' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="contract-base-title">专业及学历：</span>
          <span class="contract-base-content">{{ detail.professional || '-' }} {{ detail.education ? $getNameByKey(detail.education, '学历') : '' }}</span>
        </el-col>
      </el-row>
      </div>
    </div>

    <!-- 资质信息（横排卡片，全局 #app text-align:center 会影响 inline 内容，flex 布局不受影响） -->
    <div class="base">
      <div class="title" @click="isExpandQual = !isExpandQual">
        <div class="title-config">
          <i :class="isExpandQual ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
          资质信息
        </div>
      </div>
      <div v-show="isExpandQual" class="base-body">
      <div class="qual-cards">
        <div v-for="qual in detail.qualificationList || []" :key="qual.guid" class="qual-block">
          <div class="qual-line">
            <span class="contract-base-title">{{ qual.qualType }}：</span>
            <!-- 暂时隐藏 -->
            <!-- <span class="contract-base-content">
              {{ qual.expiryDate ? formatDate(qual.expiryDate) + ' 到期' : '' }}
            </span> -->
          </div>
          <el-image
            v-if="qualAttachPath(qual)"
            :src="qualAttachPath(qual)"
            :preview-src-list="[qualAttachPath(qual)]"
            class="qual-img"
          ></el-image>
        </div>
      </div>
      <div v-if="!(detail.qualificationList || []).length" class="empty">暂无资质信息</div>
      </div>
    </div>

    <!-- 协议签署（只读本申请留存的签署，不用当前签名/当前正文冒充历史） -->
    <div class="base protocol-box">
      <div class="title" @click="isExpandProtocol = !isExpandProtocol">
        <div class="title-config">
          <i :class="isExpandProtocol ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
          协议签署
        </div>
        <el-button v-if="protocolSignature" size="small" type="primary" icon="el-icon-document" @click.stop="viewProtocol">查看协议</el-button>
      </div>
      <div v-show="isExpandProtocol" class="base-body">
      <template v-if="protocolSignature">
        <div v-if="!protocolHasFrozenContent" class="protocol-status">
          历史申请未保存当次正文，仅保留签署记录。
        </div>
        <div class="protocol-status">
          已于 {{ formatSignTime(protocolSignature.signTime) }} 签署平台保密协议
        </div>
        <el-image
          v-if="protocolSignImg"
          :src="protocolSignImg"
          :preview-src-list="[protocolSignImg]"
          class="protocol-sign-img"
        ></el-image>
      </template>
      <div v-else-if="protocolSignatureError" class="empty">历史签名快照不可用，请联系管理员</div>
      <div v-else class="empty">该人员尚未签署平台保密协议</div>
      </div>
    </div>

    <!-- start of 流程审批 -->
    <div class="back-color-fff mt-4">
      <div class="flow">
        <approval-process v-if="processReady" :approveVO="processApproveVO" :flow-type="flowType" />
      </div>
    </div>
    <!-- end of 流程审批 -->

    <!-- 按钮区（通过/驳回仅当前待审核人可见，workFlowCommon.getBtnState） -->
    <div class="back-color-fff submit_btn_wrap">
      <el-button type="borderBlack" size="small" @click="goBack">返回</el-button>
      <template v-if="canApprove && !isReadonlyEntry">
        <el-button type="borderRed" size="small" @click="openAuditDialog('R')">驳回</el-button>
        <el-button type="importNew" size="small" @click="openAuditDialog('Y')">通过</el-button>
      </template>
    </div>

    <!-- 查看协议：展示该申请留存的版本、签名与冻结正文；legacy 明确提示正文缺失 -->
    <el-dialog title="平台保密协议（申请留存）" :visible.sync="protocolDialogVisible" append-to-body width="820px" top="8vh">
      <div v-if="protocolSignature" class="protocol-archive">
        <div class="archive-meta">
          签署时间：{{ formatSignTime(protocolSignature.signTime) }}
        </div>
        <div v-if="protocolHasFrozenContent" class="full-protocol-content" v-html="protocolSignature.protocolContent"></div>
        <div v-else class="archive-empty">历史申请未保存当次正文，无法展示签署时的协议全文。</div>
        <div v-if="protocolSignImg" class="archive-sign">
          <div class="archive-label">签名：</div>
          <img :src="protocolSignImg" alt="签名" class="protocol-sign-img" />
        </div>
      </div>
    </el-dialog>

    <!-- 通过/驳回弹窗 -->
    <el-dialog :title="auditAction === 'Y' ? '通过流程' : '驳回流程'" :visible.sync="auditDialogVisible" width="30%" top="15%">
      <el-input
        v-model="approveSuggest"
        type="textarea"
        :rows="5"
        maxlength="100"
        :placeholder="auditAction === 'Y' ? '输入通过备注（非必填）' : '输入驳回理由（必填）'"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="auditDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="info" @click="submitAudit" :loading="submitting">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import workFlowCommon from "@/uilt/workFlowCommon";

export default {
  name: "certAuditManageDetail",
  components: {
    ApprovalProcess: () => import("@/components/ApprovalProcess/index"),
  },
  data() {
    return {
      detail: {},
      processReady: false,
      processApproveVO: null,
      // 本申请留存的平台保密协议签署（detail.protocolSignature）
      protocolSignature: null,
      protocolSignatureError: false,
      protocolDialogVisible: false,
      // 区块折叠状态（questionnaireAdd 同款可折叠卡片框架）
      isExpandBase: true,
      isExpandEdu: true,
      isExpandQual: true,
      isExpandProtocol: true,
      // 花名册"认证信息"入口为只读查看（readonly=1），不展示通过/驳回操作
      isReadonlyEntry: this.$route.query.readonly === "1",
      auditDialogVisible: false,
      auditAction: "Y",
      approveSuggest: "",
      submitting: false,
    };
  },
  computed: {
    identityName() {
      const list = this.getCodeListByKey("认证身份");
      const hit = list.find((item) => item.value === this.detail.identity);
      return hit ? hit.text : this.detail.identity;
    },
    isStudent() {
      return this.detail.identity === "5";
    },
    // 当前登录人（审批按钮显隐判断用）
    currentStaffGuid() {
      try {
        return JSON.parse(localStorage.userInfo || "{}").staffGuid || "";
      } catch (e) {
        return "";
      }
    },
    // 审批中且当前登录人是待审核人才可审（workFlowCommon.getBtnState）
    canApprove() {
      const approveVO = this.detail.approveVO || {};
      return (
        workFlowCommon.getBtnState(
          "approval",
          approveVO.approveState,
          approveVO.approveStaffGuids,
          this.currentStaffGuid,
          approveVO.staffGuid
        ) === "approval"
      );
    },
    // 变更拆分独立流程(v26.3.3)：00104=认证变更单，00103/缺省=首审单
    isCertChange() {
      return this.detail.approveVO && this.detail.approveVO.flowType === "00104";
    },
    flowType() {
      return (this.detail.approveVO && this.detail.approveVO.flowType) || "00103";
    },
    // 本申请已签时回显的签名图地址（signAttach 为 JSON 串）
    protocolSignImg() {
      try {
        const attach = this.protocolSignature && this.protocolSignature.signAttach;
        return attach ? JSON.parse(attach).path : "";
      } catch (e) {
        return "";
      }
    },
    // schema2 快照才有签署时冻结正文；legacy 不补造
    protocolHasFrozenContent() {
      return !!(this.protocolSignature && this.protocolSignature.protocolContent);
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getApproveImg() {
      // 用户 09-10 指示：A 状态恢复用公共章图（ic_shenping"待审批"），不再本页单独换"审批中"章
      return workFlowCommon.getApproveImg(this.detail.approveVO && this.detail.approveVO.approveState);
    },
    formatDate(time) {
      return time ? this.$moment(time).format("YYYY-MM-DD") : "";
    },
    qualAttachPath(qual) {
      try {
        return qual.attach ? JSON.parse(qual.attach).path : "";
      } catch (e) {
        return "";
      }
    },
    showApprovalProcess(approveVO) {
      this.processApproveVO = approveVO && approveVO.camundaInstanceId && approveVO.camundaDeploymentId ? approveVO : null;
      this.processReady = true;
    },
    getDetail() {
      const guid = this.$route.query.guid;
      return this.api
        .get(`/${serverConfig.msPersonnelService}/staff-cert/detail/${guid}?tenantGuid=${localStorage.guid || ''}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.detail = res.data.data || {};
            this.sortQualifications();
            this.showApprovalProcess(this.detail.approveVO);
            this.readProtocolSignature();
          }
        });
    },
    // FOUR-2956②复测：资质证件按申请表单 buildQualList 固定顺序展示（后端查询无排序、主键随机致顺序不稳定）
    sortQualifications() {
      const order = this.detail.identity === "5"
        ? ["学生证"]
        : ["执业证书", "资格证书", "工作证/胸牌"];
      const names = { "医师执业证书": "执业证书", "医师资格证": "资格证书" };
      const idx = (t) => {
        const i = order.indexOf(t);
        // 序外类型稳定排末尾（sort 稳定，保持原相对序）
        return i === -1 ? order.length : i;
      };
      const list = this.detail.qualificationList || [];
      this.detail.qualificationList = list.map((item) => ({
        ...item, qualType: names[item.qualType] || item.qualType,
      })).sort((a, b) => idx(a.qualType) - idx(b.qualType));
    },
    // 直接读取本申请签署；兼容旧申请只存 protocolSignSnapshot 的读取路径
    readProtocolSignature() {
      this.protocolSignatureError = false;
      this.protocolSignature = null;
      const direct = this.detail.protocolSignature;
      if (direct && typeof direct === "object") {
        if (direct.signed === true && direct.signAttach) this.protocolSignature = direct;
        return;
      }
      if (this.detail.protocolSignSnapshot == null || this.detail.protocolSignSnapshot === "") return;
      try {
        const snapshot = JSON.parse(this.detail.protocolSignSnapshot);
        if (snapshot && snapshot.signed === true && snapshot.signAttach) this.protocolSignature = snapshot;
      } catch (error) {
        this.protocolSignatureError = true;
        this.$message.error("历史签名快照不可用，请联系管理员");
      }
    },
    formatSignTime(time) {
      return time ? this.$moment(time).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    // 查看当次留存的版本/签名/冻结正文；legacy 不显示当前正文冒充历史
    viewProtocol() {
      if (!this.protocolSignature) {
        this.$message.error("历史申请未保存当次签名");
        return;
      }
      this.protocolDialogVisible = true;
    },
    openAuditDialog(action) {
      this.auditAction = action;
      this.approveSuggest = "";
      this.auditDialogVisible = true;
    },
    submitAudit() {
      if (this.auditAction === "R" && !this.approveSuggest.trim()) {
        this.$message.error("驳回时必须填写驳回原因");
        return;
      }
      const userinfo = JSON.parse(localStorage.userInfo || "{}");
      const url =
        this.auditAction === "Y"
          ? `/${serverConfig.msSalesPerformService}/work-flow/data/batch-allow-flow`
          : `/${serverConfig.msSalesPerformService}/work-flow/data/batch-backup-flow`;
      this.submitting = true;
      this.api
        .postJson(url, [
          {
            approveStaffGuid: userinfo.staffGuid,
            approveSuggest: this.approveSuggest,
            // 随单取真实流程类型（00103 首审/00104 变更）；接口侧目前不读此字段，取真实值防后续启用
            flowType: (this.detail.approveVO && this.detail.approveVO.flowType) || "00103",
            funcCode: "RZSHGL",
            guid: this.detail.flowNo,
          },
        ])
        .then((res) => {
          this.submitting = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success("操作成功");
            this.auditDialogVisible = false;
            this.goBack();
          } else {
            this.$message.error(res.data.msg || "操作失败");
          }
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.contract-information-page {
  overflow: auto;
}
/* 标题条（questionnaireAdd 同款：返回按钮左上、标题居中） */
.title-box {
  border-top: 1px solid #e5e5e5;
  background-color: #ffffff;
  padding: 8px 0px;
  position: relative;
  margin-bottom: 4px;
}
.title-box button {
  font-size: 12px;
  color: #212121;
  letter-spacing: 0;
  width: 60px;
  height: 26px;
  padding: 0px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  position: absolute;
  left: 16px;
  top: 6px;
}
.title-box span {
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  color: #212121;
}
/* 可折叠卡片区块（questionnaireAdd 同款框架） */
.base {
  position: relative;
  background: #fff;
  border: 1px solid #d9d9d9;
  margin-top: 4px;
  text-align: left;
}
.base > .title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-bottom: 1px solid #ebeef5;
  background-color: #fafafa;
  cursor: pointer;
}
.title-config i {
  margin-right: 8px;
  color: #606266;
}
.base-body {
  padding: 10px 16px;
}
.approve-img {
  position: absolute;
  top: -40px;
  right: 60px;
  width: 78px;
  height: 78px;
}
/* 字段展示（FOUR-2956①：一行三列） */
.base .el-col-8,
.base .el-col-12,
.base .el-col-24 {
  display: flex;
  line-height: 22px;
  margin-bottom: 10px;
}
.base .el-col-8 .contract-base-title,
.base .el-col-12 .contract-base-title,
.base .el-col-24 .contract-base-title {
  flex-shrink: 0;
  min-width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.contract-base-content {
  /* 2026-10-08 样式反馈（image9 批注"内容部分文字色值212121"）：值文字改 #212121。
     口径反转记录：FOUR-2956④（09-05）曾按当时验收圈注从 #212121 改为 #666666，本次按产品批注改回，为终版口径 */
  color: #212121;
  text-align: left;
  flex: 1;
  min-width: 0;
  word-break: break-all;
}
/* 流程（questionnaireAdd 同款） */
.flow {
  background: #fff;
  padding-left: 20px;
}
.mt15 {
  margin-top: 15px;
}
.mt-4 {
  margin-top: 4px;
}
.ml10 {
  margin-left: 10px;
}
.qual-block {
  margin-bottom: 0;
}
.qual-line {
  display: flex;
  line-height: 22px;
  margin-bottom: 8px;
}
/* FOUR-2956①复测：证件名不在 el-col 内，不吃 .base .el-col-8 的字段名色值定义，补齐与字段名同色 */
.qual-line .contract-base-title {
  color: #666666;
}
.qual-img {
  width: 200px;
  height: 120px;
  border: 1px solid #ebeef5;
}
/* FOUR-2956③复测：object-fit 须作用于内部 img（写在容器上无效，el-image 内部 img 默认 fill 拉伸变形） */
.qual-img /deep/ img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.protocol-sign-img /deep/ img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.empty {
  color: #909399;
}
/* 协议签署（页面全局 #app 为 text-align:center，须显式左对齐） */
.protocol-box {
  text-align: left;
}
.full-protocol-content {
  max-height: 65vh;
  overflow-y: auto;
  line-height: 1.8;
  text-align: left;
}
.protocol-status {
  font-size: 14px;
  color: #212121;
  margin-bottom: 10px;
}
/* 查看协议弹框：当次版本 + 冻结正文 + 签名 */
.protocol-archive {
  text-align: left;
}
.archive-meta {
  margin-bottom: 12px;
  color: #606266;
  font-size: 14px;
}
.archive-empty {
  padding: 12px;
  color: #e6a23c;
  background: #fdf6ec;
  border-radius: 4px;
}
.archive-sign {
  margin-top: 12px;
}
.archive-label {
  margin-bottom: 8px;
  color: #606266;
}
/* 签名画布 600x200，固定 3:1 尺寸防拉伸（block/无宽会被 inner img width:100% 撑满整行） */
.protocol-sign-img {
  width: 360px;
  height: 120px;
  margin-bottom: 12px;
  border: 1px solid #ebeef5;
  background: #fafafa;
}
/* 资质横排卡片 */
.qual-cards {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}
</style>
